import { InteractionInterface } from './InteractionInterface'
import GeogebraRender from '../components/interactions/geogebraRender.vue'

export class geogebraInteraction extends InteractionInterface {
  constructor(question, testData) {
    super(question)
    this.testData = testData
    this.userAnswer = {
      answers: '',
      correct: false,
      score: 0,
      base64Data: '',
      hintUsed: false
    }
  }

  render() {
    return {
      component: GeogebraRender,
      props: {
        question: this.question,
        testData: this.testData,
        restoredAnswer: this.userAnswer,
        numOrder: this.question.numOrder || null,
        readOnly: false,
        isAgent: false,
        showFeedback: false
      }
    }
  }

  restoreAnswer(savedAnswer) {
    if (savedAnswer && typeof savedAnswer === 'object') {
      this.userAnswer = {
        ...this.userAnswer,
        ...savedAnswer
      }
    }
  }

  calculateScore(userAnswer) {
    if (!userAnswer || typeof userAnswer !== 'object') {
      return 0
    }

    // If score is already calculated in the answer (from GeoGebra variables)
    if (typeof userAnswer.score === 'number') {
      return userAnswer.score
    }

    // Fallback: match correct mode
    if (userAnswer.correct) {
      return this.question.maxScore || 1
    }

    return 0
  }

  saveAnswer() {
    return this.userAnswer
  }

  // Additional method for GeoGebra-specific data
  getResponseData() {
    return {
      el_ID: this.question.el_ID,
      el_Type: this.question.el_Type,
      response: this.userAnswer,
      score: this.calculateScore(this.userAnswer),
      maxScore: this.question.maxScore || 1,
      correct: this.userAnswer.correct || false,
      timestamp: new Date().toISOString(),
      hintUsed: this.userAnswer.hintUsed || false
    }
  }
}
